import { FC } from 'react';
import classNames from 'classnames';
import { FadeContainer, FadeText } from 'components/CustomAnimations';
import OrbsContainer from 'components/LottieElements/OrbsContainer';

interface Props {
  text: string;
  name: string;
  role: string;
  delay?: number;
  image?: string;
}
const EXTRA_DELAY = 0.5;

export const Quote: FC<Props> = ({ text, name, role, delay = 0.5, image }) => {
  return (
    <OrbsContainer jsonType="quote_module">
      <div className="quote-content">
        <FadeText inViewTrigger delay={delay} className="h2-desktop" text={text} />
        <FadeContainer inViewTrigger delay={delay + EXTRA_DELAY} className="quote-name-container">
          {image && <img src={image} alt="Quote image" />}
          <div className={classNames('quote-texts', { 'text-center': !image })}>
            <FadeText inViewTrigger delay={delay + EXTRA_DELAY} className="body-text" text={name} />
            <FadeText
              inViewTrigger
              delay={delay + EXTRA_DELAY}
              className="body-small-text"
              text={role}
            />
          </div>
        </FadeContainer>
      </div>
    </OrbsContainer>
  );
};
